import { render, staticRenderFns } from "./HorneadasCongeladas.vue?vue&type=template&id=89014b88&scoped=true&"
import script from "./HorneadasCongeladas.vue?vue&type=script&lang=js&"
export * from "./HorneadasCongeladas.vue?vue&type=script&lang=js&"
import style0 from "./HorneadasCongeladas.vue?vue&type=style&index=0&id=89014b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89014b88",
  null
  
)

export default component.exports